import { useContext, useEffect } from "react";
import { ChangeTitleContext } from "../context/ThemeContext";

export function useThemeTitle(title: string, description?: string) {
  const changeTitle = useContext(ChangeTitleContext);
  useEffect(() => {
    changeTitle(title, description);
  }, [changeTitle, description, title]);
}
